module.exports = __webpack_public_path__ + "static/assets/b84b7b211beac430080858d8911faeb1.png";